var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('event-header',{attrs:{"event":_vm.event}}),_c('div',{staticClass:"mt-8 rounded-lg shadow-lg overflow-hidden",attrs:{"id":"event-manager"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }